import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './CompanyItem.css';
import { HOST } from '../../constants/Fetch'
import getNoun from '../../utils/getNoun.js';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setFilterData } from "../../actions/FiltersActions";

class CompanyItem extends Component {


  render() {
    const card = this.props.card;
    return (
      <div key={card.key} className={`companyItem ${this.props.modifier ? this.props.modifier : ''} ${this.props.minify ? 'companyItem--minify' : ''}`}>
        <Link to={`/company${card.id}`} className="companyItem__linkWrapper">
          {
            card.logo &&
            <div className="companyItem__logoWrapper">
              <img className="companyItem__logoInner" src={HOST + card.logo} alt={card.name} />
            </div>
          }
          <div className="companyItem__name">{card.name}</div>
          {
            !this.props.minify &&
            <div className={`companyItem__description`}>{card.preview}</div>
          }
          {
            this.props.inVacancy &&
            <span className="companyItem__about">О компании</span>
          }
        </Link>
        {
          (!this.props.minify && !this.props.inVacancy) &&
          <div className="companyItem__vacancies">
            <Link onClick={() => this.props.handleClick(card.id, card.name)} to="/vacancies" className="companyItem__vacanciesLink">{card.vacancy_count} {getNoun(card.vacancy_count, 'вакансия', 'вакансии', 'вакансий')}</Link>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      filter: state.filter
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleClick: (val, label) => {
      dispatch(setFilterData(val, label, 'company'))
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyItem));




// WEBPACK FOOTER //
// ./src/components/CompanyItem/index.js